import { render, staticRenderFns } from "./TamilSchool.vue?vue&type=template&id=dd9c022c"
import script from "./TamilSchool.vue?vue&type=script&lang=js"
export * from "./TamilSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports